var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apex-charts',{attrs:{"type":"pie","options":_vm.chartOptions,"series":this.values,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }